import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
} from "constants/FormatDataContanst";
import { TYPE_AUTO_RELOAD } from "pages/IssueInvoice/utils";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const AutoReloadList = props => {
  const { actionReset, actionReload, dataCheck, listData } = props;

  const [isAutoReload, setIsAutoReload] = useState(false);
  const [numOfAutoReload, setNumOfAutoReload] = useState(0);
  const TIME_BETWEEN_AUTO_RELOAD = 3000; // Thời gian giữa mỗi lần auto reload
  const MAX_NUM_OF_AUTO_RELOAD = 6; // Số lần reload tối đa

  const resetDataReload = () => {
    setNumOfAutoReload(0);
    actionReset && actionReset();
  };

  const startAutoReload = () => {
    if (numOfAutoReload === MAX_NUM_OF_AUTO_RELOAD) {
      resetDataReload();
    } else {
      setIsAutoReload(true);
    }
  };

  useEffect(() => {
    if (listData.length > 0 && dataCheck) {
      // Kiếm tra hóa đơn vừa dc tạo mới trong list
      const dataNew = listData.find(item => item.id === dataCheck.id);
      if (dataNew) {
        switch (dataCheck.typeAutoReload) {
          case TYPE_AUTO_RELOAD.IS_REPLACE:
          case TYPE_AUTO_RELOAD.IS_ADJUST:
          case TYPE_AUTO_RELOAD.IS_NEW:
            if (!dataNew.resource_id) {
              // Nếu chưa có xml (resource_id null) thì auto reload
              startAutoReload();
            } else {
              resetDataReload();
            }
            break;
          case TYPE_AUTO_RELOAD.IS_RELEASE:
            if (
              dataNew.auth_status === AUTH_STATUS_NEW ||
              dataNew.auth_status === AUTH_STATUS_PROGRESSING
            ) {
              // Sau khi phát hành nếu trạng thái vẫn còn là lưu tạm hoặc chờ phát hành thì auto reload
              startAutoReload();
            } else {
              resetDataReload();
            }
            break;
          case TYPE_AUTO_RELOAD.IS_RELEASE_ERROR_INVOICE:
            if (
              dataNew.auth_status === AUTH_STATUS_NEW ||
              dataNew.auth_status === AUTH_STATUS_PROGRESSING
            ) {
              // Sau khi phát hành nếu trạng thái vẫn còn là lưu tạm hoặc chờ phát hành thì auto reload
              startAutoReload();
            } else {
              resetDataReload();
            }
            break;
          case TYPE_AUTO_RELOAD.IS_CANCEL:
            if (
              dataNew.auth_status === AUTH_STATUS_CANCEL_WAITING ||
              dataNew.auth_status === AUTH_STATUS_APPROVE
            ) {
              // Sau khi hủy nếu trạng thái vẫn còn là phát hành hoặc chờ duyệt hủy thì auto reload
              startAutoReload();
            } else {
              resetDataReload();
            }
            break;
          case TYPE_AUTO_RELOAD.IS_SEND_MAIL:
            if (Number(dataNew.sent) === 0) {
              // Sau khi gửi mail nếu trạng thái vẫn còn là chở gửi mail thì auto reload
              startAutoReload();
            } else {
              resetDataReload();
            }
            break;
          default:
            break;
        }
      } else {
        resetDataReload();
      }
    }
  }, [listData]);

  useEffect(() => {
    return () => {
      actionReset && actionReset();
    };
  }, []);

  useEffect(() => {
    let timeout = null;
    if (isAutoReload) {
      setTimeout(() => {
        setNumOfAutoReload(numOfAutoReload + 1);
        actionReload && actionReload();
        setIsAutoReload(false);
      }, TIME_BETWEEN_AUTO_RELOAD);
    }
    return () => {
      // clears timeout before running the new effect
      clearTimeout(timeout);
    };
  }, [isAutoReload]);

  return <React.Fragment></React.Fragment>;
};

AutoReloadList.propTypes = {
  actionReset: PropTypes.func,
  actionReload: PropTypes.func,
  dataCheck: PropTypes.object,
  listData: PropTypes.array,
};

export default AutoReloadList;
